module.exports = __webpack_public_path__ + "static/04-cb1e9413021e691e94892c2003622fa4.jpg";